import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import { LOADING } from "../../store/actions";
import instance from "../../store/axios";

export interface ChartDataResponse {
  data: {
    month_name: string;
    month_date: string;
    trx_type: "Redemption" | "Subscription" | "Deposit" | "Withdrawal";
    trx_count: number;
    amount_kwd: string;
  }[];
  message: string;
}

export interface DashTransactionsResponse {
  data: {
    items: {
      id: number;
      portfolioId: number;
      createdAt: string;
      updatedAt: string;
      amount: number;
      currency: string;
      amount_kwd: string;
      status: string;
      userId: number;
      accountId: number;
      source: string;
      fundNameEn: string;
      transactiontype: "Redemption" | "Subscription" | "Deposit" | "Withdrawal";
      accountCode: number;
      nameEn: string;
    }[];
    totalPages: number;
    currentPage: number;
    pageSize: number;
    totalCount: number;
    subscriptionBreakdown?: {
      fundNameEn: string;
      month: string;
      total: number;
    }[];
  };
  message: string;
}


class CeoDashboardService {
  private dispatch = useDispatch();

  public async getDashboardTransactionsSummaryMonth(params: {
    dateFrom: string;
    dateTo: string;
    trxType?: string;
  }): Promise<ChartDataResponse | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      let query = `?dateFrom=${params.dateFrom}&dateTo=${params.dateTo}`;
      if (params.trxType) {
        query += `&trxType=${params.trxType}`;
      }
      const response: AxiosResponse<ChartDataResponse> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/dash-transactions-summ-month${query}`
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", "/home/ceo-dashboard");
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async getDashboardTransactions(params?: {
    dateFrom?: string;
    dateTo?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    transactionType?: string;
    status?: string;
  }): Promise<DashTransactionsResponse | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      let query = "";
      if (params) {
        const queryParams = new URLSearchParams();
        if (params.dateFrom) queryParams.append("dateFrom", params.dateFrom);
        if (params.dateTo) queryParams.append("dateTo", params.dateTo);
        if (params.page) queryParams.append("page", params.page.toString());
        if (params.pageSize)
          queryParams.append("pageSize", params.pageSize.toString());
        if (params.search) queryParams.append("search", params.search);
        if (params.transactionType) queryParams.append("transactionType", params.transactionType);
        if (params.status) queryParams.append("status", params.status);
        query = queryParams.toString() ? `?${queryParams.toString()}` : "";
      }

      const response: AxiosResponse<DashTransactionsResponse> =
        await instance.get(
          `/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/dash-transactions${query}`
        );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", "/home/ceo-dashboard");
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default CeoDashboardService;
